import { useContext, useEffect, useMemo, useState } from "react";
import FGInput from "../dumb/FGInput";
import AppUser from "../../modules/app-user/app-user";
import Debouncer from "../../modules/debouncer/debouncer";
import AppUserContext from "../../context/app-user-context";
import ApiUser from "../../modules/api/user";
import Notifier from "../../modules/notifier/notifier";

export default function ChangeAlias({
  description = <>Would you like to set an Alias (a name by which you would like to be called)?</>,
  showDescription = false,
  showOnOnlyEmpty = false,
  className = ""
}: {
  description?: string | JSX.Element | JSX.Element[];
  showDescription?: boolean,
  showOnOnlyEmpty?: boolean,
  className?: string;
}) {
  const [show, setShow] = useState(true);
  const [alias, setAlias] = useState("");
  const [aliasOnServer, setAliasOnServer] = useState("");
  const [processing, setProcessing] = useState(false);
  const user = useContext(AppUserContext);

  useEffect(() => {
    AppUser.getInfo().then(res => {
      setAlias(res.alias ?? "");
      setAliasOnServer(res.alias ?? "");
    });
  }, []);

  const handleOnSubmit = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    setProcessing(true);
    Debouncer.execute("CHANGE_ALIAS", async () => {
      const res = await ApiUser.updateAvatar({
        alias: alias,
        avatar: "",
        modifiedUserId: user.id,
        id: user.referenceUserId
      });

      if (res.status) {
        setAliasOnServer(alias);
        await AppUser.refreshUser();
        Notifier.success("Alias updated");
      } else {
        Notifier.error(res.message);
      }

      setProcessing(false);
    });
  };

  useEffect(() => {
    if (!showOnOnlyEmpty) {
      return;
    }

    setShow(aliasOnServer === "")
  }, [showOnOnlyEmpty, aliasOnServer]);

  const classNameParent = useMemo(() => `change-alias ${className}`.trim(), [className]);

  return <div data-comp="ChangeAlias">
    {show && <div className={classNameParent}>
      {showDescription && description && <div className="ca__description">
        {description}
      </div>}
      <form onSubmit={handleOnSubmit}>
        <div className="ca__box">
          <FGInput label="" variant={"normal"} value={alias} maxLength={24}
            onChange={(e) => setAlias(e?.target?.value ?? "")}
            disabled={processing}
          />
          <button className="btn btn-secondary" type="submit"
            disabled={processing}
          >Save</button>
        </div>
      </form>
    </div>}
  </div>;
}
